import requests from './httpService';
const FeeMasterService = {
  getAllFeeMaster(id) {
    return requests.get(`/feemaster/list/${id}`);
  },

  creteFeeMaster(body){
    return requests.post('/feemaster/add',body); 
  },
  deleteFeeMaster(body){
    return requests.delete(`/feemaster/${body._id}`); 
  },

  upadeFeeMaster(body) {
    return requests.put(`/feemaster/${body._id}`,body); 
  },

  getFeeMasterNameById(body){
    return requests.post('/feemaster/getFeeMasterNameById',body);
  },


};

export default FeeMasterService;
